<nz-layout>
    <nz-content>
        <div class="card padded">
            <form nz-form [formGroup]="labForm" [nzLayout]="'inline'">
                <nz-form-item
                    *ngFor="let field of fields"
                    [style]="
                        (field.type === 'divider'
                            ? 'width: 100%; margin-top: 12px;'
                            : field.type === 'break'
                              ? 'flex-basis: 100%;height: 0;min-height: unset;'
                              : field.type === 'list'
                                ? 'width: 100%;'
                                : 'max-width: 100%;') +
                        (field.level === 'child' ? 'padding-left: 4px;' : '')
                    "
                >
                    <h4
                        *ngIf="field.type === 'divider'; else formItem"
                        style="text-align: left"
                    >
                        {{ field.label }}
                    </h4>

                    <ng-template #formItem style="margin-left: 12px">
                        <nz-divider
                            *ngIf="field.level === 'child'"
                            nzType="vertical"
                        ></nz-divider>

                        <nz-form-label
                            [style]="
                                field.type === 'boolean'
                                    ? 'order: 1;'
                                    : 'order: 0;'
                            "
                            *ngIf="field.label"
                            [nzNoColon]="field.type === 'boolean'"
                            [nzFor]="field.id"
                            [nzRequired]="field.required"
                            style="white-space: normal"
                            >{{ field.label }}</nz-form-label
                        >

                        <nz-form-control
                            [style]="
                                field.type === 'boolean'
                                    ? 'order: 0;width: 24px;'
                                    : 'order: 1;'
                            "
                            nzErrorTip="Error"
                        >
                            <label
                                *ngIf="field.type === 'boolean'; else inputTmp"
                                class="check"
                                nz-checkbox
                                [formControlName]="field.id"
                            ></label>
                            <ng-template #inputTmp>
                                <input
                                    *ngIf="
                                        field.type === 'string' ||
                                        field.type === 'number'
                                    "
                                    nz-input
                                    [type]="field.type"
                                    [formControlName]="field.id"
                                    [id]="field.id"
                                />
                                <!-- <input
                                    *ngIf="field.type === 'list'"
                                    [type]="'string'"
                                    [formControlName]="field.id"
                                /> -->
                                <my-health-admin-dynamic-form-item
                                    *ngIf="field.type === 'list'"
                                    [name]="field.id"
                                    [data]="labForm.value[field.id]"
                                    (itemsCompleted)="
                                        handleItemsCompleted($any($event))
                                    "
                                ></my-health-admin-dynamic-form-item>
                            </ng-template>
                        </nz-form-control>
                    </ng-template>

                    <div style="display: flex; flex-direction: column">
                        <my-health-admin-lab-requisition-element
                            *ngFor="let element of field.elements"
                            [parentId]="field.id"
                            [element]="element"
                            [labReq]="labReq"
                            (valueChanged)="handleElementChanged($event)"
                        ></my-health-admin-lab-requisition-element>
                    </div>
                </nz-form-item>

                <nz-divider></nz-divider>

                <nz-form-item>
                    <nz-form-label [nzFor]="'dueDate'" [nzRequired]="true">
                        Due Date
                    </nz-form-label>
                    <nz-form-control>
                        <nz-date-picker
                            nzFormat="yyyy-MM-dd"
                            [formControlName]="'dueDate'"
                            nzPlaceHolder="Select Due Date"
                            [nzRenderExtraFooter]="footerTemplate"
                        ></nz-date-picker>
                        <ng-template #footerTemplate>
                            <button
                                nz-button
                                nzType="link"
                                (click)="setDueDate(3)"
                            >
                                3 Months
                            </button>
                            <button
                                nz-button
                                nzType="link"
                                (click)="setDueDate(6)"
                            >
                                6 Months
                            </button>
                            <button
                                nz-button
                                nzType="link"
                                (click)="setDueDate(12)"
                            >
                                1 Year
                            </button>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>

                <nz-divider></nz-divider>

                <div
                    nz-row
                    nzType="flex"
                    nzJustify="space-around"
                    class="button-group"
                >
                    <button
                        nz-button
                        nzType="primary"
                        nzShape="round"
                        (click)="saveLabReq()"
                        [nzLoading]="saving"
                    >
                        {{ labReq ? 'Save Lab Req' : 'Create Lab Req' }}
                    </button>
                    <button
                        nz-button
                        nzType="primary"
                        nzShape="round"
                        (click)="close()"
                        [disabled]="saving"
                    >
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    </nz-content>
</nz-layout>
